import type React from 'react';
import { useMemo } from 'react';
import useMainHooks from '../hooks/use-main-hooks';
import { DiagramContext } from './diagram.context';

interface DiagramContextProps {
  children: React.ReactNode;
}

export const DiagramContextProvider: React.FC<DiagramContextProps> = ({ children }: DiagramContextProps) => {
  const { isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId } = useMainHooks();

  const value = useMemo(
    () => ({ isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId }),
    [isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId]
  );
  return <DiagramContext.Provider value={value}>{children}</DiagramContext.Provider>;
};
